import {ILevelMapAggregatedTile, ILevelMapTileProgress, TileType} from "../types";
import {call, fork, put, select, take} from "redux-saga/effects";
import {openTile, setLevelProgress} from "../actions";
import {ActionType, getType} from "typesafe-actions";
import {loadScene} from "../../routing/actions";
import {IApplicationState} from "../../index";
import {delay} from "redux-saga";
import {handleQuestionTile} from "./tileHandlers/handleQuestionTile";
import {processConnectedTiles} from "./tileHandlers/processConnectedTiles";
import {handleChestGameTile} from "./tileHandlers/handleChestGameTile";
import {handleCardsGameTile} from "./tileHandlers/handleCardsGameTile";
import {changePlayerStats} from "./tileHandlers/changePlayerStats";
import {processLevelComplete} from "./processLevelComplete";
import {handleExitTile} from "./tileHandlers/handleExitTile";
import tryCreateShortcut from "../../../shared/utils/tryCreateShortcut";

let answeredQuestions = 0;

function* handleTile (tile: ILevelMapAggregatedTile) {
    switch (tile.tileType) {
        case TileType.Exit:
            return yield call(handleExitTile, tile);

        case TileType.SimpleQuestion:
            return yield call(handleQuestionTile, tile);

        case TileType.ChestGame:
            return yield call(handleChestGameTile, tile);

        case TileType.CardsGame:
            return yield call(handleCardsGameTile, tile);
    }

    return {};
}

export default function* handleOpenTile({ payload: tile }: ActionType<typeof openTile>) {
    const {existingProgress, animation} = yield select(({ game, settings }: IApplicationState) => ({
        existingProgress: game.levelMapTileProgress[tile.id],
        animation: settings.animation
    }));

    if (!tile.isRevealed && !existingProgress.isRevealed)
        return;

    const tileProgress = yield call(handleTile, tile);

    const progress: ILevelMapTileProgress = {
        id: tile.id,
        isRevealed: true,
        isAnswered: false,
        isRight: false,
        timestamp: new Date().getTime(),

        ...tileProgress
    };

    yield put(loadScene.request('LevelMap'));

    if (!progress.isAnswered)
        return;

    const levelIsCompleted = tile.tileType === TileType.Exit;

    yield take(getType(loadScene.success));

    yield delay(100);

    yield put(setLevelProgress({
        isCompleted: levelIsCompleted,
        levelProgress: {
            [tile.id]: progress
        }
    }));

    yield call(changePlayerStats, progress, tile);

    if (levelIsCompleted) {
        const delay = animation.enabled
            ? (progress.score
                ? 3200
                : 1200) / animation.timeScale
            : 500;

        yield fork(processLevelComplete, tile.levelId, delay)
    } else {
        yield fork(processConnectedTiles, tile);

        if (answeredQuestions++ >= 15 && tile.tileType === TileType.SimpleQuestion && progress.isRight) {
            yield fork(tryCreateShortcut);
        }
    }
}